// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toast_toast-container__t2VI3 {
  display: flex;
  flex-direction: column-reverse;
  gap: 12px;
  position: fixed;
  z-index: var(--m-z-index-toast, 11000);
  top: auto;
  right: auto;
  left: 20px;
  bottom: 20px;
  color: var(--m-white);
  width: 400px;
  max-width: min(400px, 100vw - 24px);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 991.88px) {
  .Toast_toast-container__t2VI3 {
    left: 12px;
    right: 12px;
    bottom: 12px;
    width: auto;
    max-width: none;
  }
}
.Toast_toast-container__t2VI3 .Toast_children-container__tKVoH {
  flex-shrink: 0;
}
.Toast_toast-container__toast__5k9qk {
  background-color: #1f1f1f;
  padding: 16px;
  font-size: 13px;
  border-radius: 4px;
  color: var(--m-subtle-xbolder);
  transition: opacity ease-in-out 0.2s;
  box-shadow: 0 0.5rem 0.75rem rgba(9, 30, 66, 0.1490196078), 0 0 0.0625rem rgba(9, 30, 66, 0.3098039216);
  animation: Toast_slideInLeft__z\\+0W4 0.3s ease-in forwards;
  border: 1px solid transparent;
  flex-shrink: 0;
}
.Toast_toast-container__toast--title__kcrFw {
  font-size: 14px;
  font-weight: 500;
  margin-left: 10px;
}
.Toast_toast-container__toast--icon-title__kezw5 {
  font-size: 24px;
}
.Toast_toast-container__toast--close__UBlT7 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  cursor: pointer;
}
.Toast_toast-container__toast--close__UBlT7 svg {
  font-size: 18px;
}
.Toast_toast-container__toast--expand__ArSDf {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
}
.Toast_toast-container__toast--expand__ArSDf svg {
  font-size: 20px;
}
.Toast_toast-container__toast--rotate__o21aN {
  transform: rotate(180deg);
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__vhEya {
  height: 0;
  visibility: hidden;
  box-sizing: border-box;
  overflow: hidden;
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content--visible__uf1Vj {
  height: 100%;
  visibility: visible;
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__description__hGdgj {
  margin-left: 32px;
  font-size: 14px;
  font-weight: 400;
  width: 80%;
  max-width: 80%;
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons__i\\+Urv {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--button__rz0L3 {
  padding: 0 12px;
  font-size: 14px;
  font-weight: 500;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: var(--m-border-radius);
  line-height: 24px;
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--warning__\\+Q9zX, .Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--danger__Hiph0 {
  background-color: rgba(0, 0, 0, 0.14);
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--warning__\\+Q9zX:hover, .Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--danger__Hiph0:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--warning__\\+Q9zX:active, .Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--danger__Hiph0:active {
  background-color: rgba(0, 0, 0, 0.3);
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--info__GGs-Z, .Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--success__iaSi2 {
  background-color: rgba(0, 0, 0, 0.2);
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--info__GGs-Z:hover, .Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--success__iaSi2:hover {
  background-color: rgba(0, 0, 0, 0.28);
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--info__GGs-Z:active, .Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--success__iaSi2:active {
  background-color: rgba(0, 0, 0, 0.32);
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--link__kILC0 {
  color: var(--m-primary);
}
.Toast_toast-container__toast__5k9qk .Toast_toast-content__buttons--link__kILC0:hover {
  text-decoration: underline;
}
.Toast_toast-container__toast__5k9qk:hover {
  opacity: 1;
}

/* Root-level modifiers so css-loader always exports them (nested &.success on &__toast often does not). */
.Toast_toastAppearanceDefault__85\\+wg,
.Toast_toastAppearanceLink__k1-RF {
  background-color: var(--m-white);
  color: var(--m-text);
}
.Toast_toastAppearanceDefault__85\\+wg .Toast_info-icon__890G7,
.Toast_toastAppearanceLink__k1-RF .Toast_info-icon__890G7 {
  color: var(--m-primary);
}

.Toast_toastAppearanceSuccess__Fx1hj {
  background-color: var(--m-success, #039e68) !important;
  color: #ffffff !important;
}

.Toast_toastAppearanceWarning__Lk\\+3L {
  background-color: var(--m-warning, #f5cd47) !important;
  color: #172b4d !important;
}

.Toast_toastAppearanceDanger__WKZ4z {
  background-color: var(--m-danger, #ca371c) !important;
  color: #ffffff !important;
}

.Toast_toastAppearanceInfo__HDq79 {
  background-color: var(--m-primary, #00b4f3) !important;
  color: #ffffff !important;
}

[m-data-theme=dark] .Toast_toastAppearanceDefault__85\\+wg,
[m-data-theme=dark] .Toast_toastAppearanceLink__k1-RF,
[m-data-theme=dark] .Toast_toastAppearanceInfo__HDq79 {
  background-color: #34455f;
  color: var(--m-text);
}
[m-data-theme=dark] .Toast_toastAppearanceDefault__85\\+wg .Toast_info-icon__890G7,
[m-data-theme=dark] .Toast_toastAppearanceLink__k1-RF .Toast_info-icon__890G7,
[m-data-theme=dark] .Toast_toastAppearanceInfo__HDq79 .Toast_info-icon__890G7 {
  color: var(--m-primary);
}
[m-data-theme=dark] .Toast_toastAppearanceDefault__85\\+wg,
[m-data-theme=dark] .Toast_toastAppearanceLink__k1-RF,
[m-data-theme=dark] .Toast_toastAppearanceInfo__HDq79 {
  border-color: rgba(255, 255, 255, 0.2);
}
[m-data-theme=dark] .Toast_toastAppearanceSuccess__Fx1hj,
[m-data-theme=dark] .Toast_toastAppearanceWarning__Lk\\+3L,
[m-data-theme=dark] .Toast_toastAppearanceDanger__WKZ4z {
  color: #162949;
}
@keyframes Toast_slideInLeft__z\\+0W4 {
  0% {
    transform: translateX(-100%);
  }
  75% {
    transform: translateX(-20%);
  }
  100% {
    transform: translateX(0%);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/Toast/Toast.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,sCAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,mCAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EAjBF;IAkBI,UAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;EAEF;AACF;AAAE;EACE,cAAA;AAEJ;AACE;EACE,yBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,oCAAA;EACA,uGAAA;EAEA,0DAAA;EACA,6BAAA;EACA,cAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AACN;AAEI;EACE,eAAA;AAAN;AAGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AADN;AAGM;EACE,eAAA;AADR;AAKI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAHN;AAKM;EACE,eAAA;AAHR;AAOI;EACE,yBAAA;AALN;AAQI;EACE,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AANN;AAQM;EACE,YAAA;EACA,mBAAA;AANR;AASM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAPR;AAUM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AARR;AAUQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qCAAA;EACA,iBAAA;AARV;AAWQ;EAEE,qCAAA;AAVV;AAYU;EACE,oCAAA;AAVZ;AAaU;EACE,oCAAA;AAXZ;AAeQ;EAEE,oCAAA;AAdV;AAgBU;EACE,qCAAA;AAdZ;AAiBU;EACE,qCAAA;AAfZ;AAmBQ;EACE,uBAAA;AAjBV;AAmBU;EACE,0BAAA;AAjBZ;AAuBI;EACE,UAAA;AArBN;;AA0BA,0GAAA;AACA;;EAEE,gCAAA;EACA,oBAAA;AAvBF;AAyBE;;EACE,uBAAA;AAtBJ;;AA0BA;EACE,sDAAA;EACA,yBAAA;AAvBF;;AA0BA;EACE,sDAAA;EACA,yBAAA;AAvBF;;AA0BA;EACE,qDAAA;EACA,yBAAA;AAvBF;;AA0BA;EACE,sDAAA;EACA,yBAAA;AAvBF;;AA2BE;;;EAGE,yBAAA;EACA,oBAAA;AAxBJ;AA0BI;;;EACE,uBAAA;AAtBN;AAeE;;;EAUE,sCAAA;AApBJ;AAuBE;;;EAGE,cAAA;AArBJ;AAqCA;EACE;IACE,4BAAA;EAvBF;EAyBA;IACE,2BAAA;EAvBF;EAyBA;IACE,yBAAA;EAvBF;AACF","sourcesContent":[".toast-container {\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 12px;\n  position: fixed;\n  z-index: var(--m-z-index-toast, 11000);\n  top: auto;\n  right: auto;\n  left: 20px;\n  bottom: 20px;\n  color: var(--m-white);\n  width: 400px;\n  max-width: min(400px, calc(100vw - 24px));\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  @media (max-width: 991.88px) {\n    left: 12px;\n    right: 12px;\n    bottom: 12px;\n    width: auto;\n    max-width: none;\n  }\n\n  .children-container {\n    flex-shrink: 0;\n  }\n\n  &__toast {\n    background-color: #1f1f1f;\n    padding: 16px;\n    font-size: 13px;\n    border-radius: 4px;\n    color: var(--m-subtle-xbolder);\n    transition: opacity ease-in-out 0.2s;\n    box-shadow: 0 0.5rem 0.75rem #091e4226, 0 0 0.0625rem #091e424f;\n    -webkit-animation: slideInLeft 0.3s ease-in forwards;\n    animation: slideInLeft 0.3s ease-in forwards;\n    border: 1px solid transparent;\n    flex-shrink: 0;\n\n    &--title {\n      font-size: 14px;\n      font-weight: 500;\n      margin-left: 10px;\n    }\n\n    &--icon-title {\n      font-size: 24px;\n    }\n\n    &--close {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 25px;\n      height: 25px;\n      border-radius: 50%;\n      cursor: pointer;\n\n      svg {\n        font-size: 18px;\n      }\n    }\n\n    &--expand {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 30px;\n      height: 30px;\n      border-radius: 50%;\n      cursor: pointer;\n\n      svg {\n        font-size: 20px;\n      }\n    }\n\n    &--rotate {\n      transform: rotate(180deg);\n    }\n\n    .toast-content {\n      height: 0;\n      visibility: hidden;\n      box-sizing: border-box;\n      overflow: hidden;\n\n      &--visible {\n        height: 100%;\n        visibility: visible;\n      }\n\n      &__description {\n        margin-left: 32px;\n        font-size: 14px;\n        font-weight: 400;\n        width: 80%;\n        max-width: 80%;\n      }\n\n      &__buttons {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        margin-top: 10px;\n\n        &--button {\n          padding: 0 12px;\n          font-size: 14px;\n          font-weight: 500;\n          height: 32px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          border-radius: var(--m-border-radius);\n          line-height: 24px;\n        }\n\n        &--warning,\n        &--danger {\n          background-color: rgba(0, 0, 0, 0.14);\n\n          &:hover {\n            background-color: rgba(0, 0, 0, 0.2);\n          }\n\n          &:active {\n            background-color: rgba(0, 0, 0, 0.3);\n          }\n        }\n\n        &--info,\n        &--success {\n          background-color: rgba(0, 0, 0, 0.2);\n\n          &:hover {\n            background-color: rgba(0, 0, 0, 0.28);\n          }\n\n          &:active {\n            background-color: rgba(0, 0, 0, 0.32);\n          }\n        }\n\n        &--link {\n          color: var(--m-primary);\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n/* Root-level modifiers so css-loader always exports them (nested &.success on &__toast often does not). */\n.toastAppearanceDefault,\n.toastAppearanceLink {\n  background-color: var(--m-white);\n  color: var(--m-text);\n\n  .info-icon {\n    color: var(--m-primary);\n  }\n}\n\n.toastAppearanceSuccess {\n  background-color: var(--m-success, #039e68) !important;\n  color: #ffffff !important;\n}\n\n.toastAppearanceWarning {\n  background-color: var(--m-warning, #f5cd47) !important;\n  color: #172b4d !important;\n}\n\n.toastAppearanceDanger {\n  background-color: var(--m-danger, #ca371c) !important;\n  color: #ffffff !important;\n}\n\n.toastAppearanceInfo {\n  background-color: var(--m-primary, #00b4f3) !important;\n  color: #ffffff !important;\n}\n\n[m-data-theme=\"dark\"] {\n  .toastAppearanceDefault,\n  .toastAppearanceLink,\n  .toastAppearanceInfo {\n    background-color: #34455f;\n    color: var(--m-text);\n\n    .info-icon {\n      color: var(--m-primary);\n    }\n\n    border-color: rgba($color: #fff, $alpha: 0.2);\n  }\n\n  .toastAppearanceSuccess,\n  .toastAppearanceWarning,\n  .toastAppearanceDanger {\n    color: #162949;\n  }\n}\n\n@-webkit-keyframes slideInLeft {\n  0% {\n    transform: translateX(-100%);\n  }\n  75% {\n    transform: translateX(-20%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n}\n\n@keyframes slideInLeft {\n  0% {\n    transform: translateX(-100%);\n  }\n  75% {\n    transform: translateX(-20%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast-container": `Toast_toast-container__t2VI3`,
	"children-container": `Toast_children-container__tKVoH`,
	"toast-container__toast": `Toast_toast-container__toast__5k9qk`,
	"slideInLeft": `Toast_slideInLeft__z+0W4`,
	"toast-container__toast--title": `Toast_toast-container__toast--title__kcrFw`,
	"toast-container__toast--icon-title": `Toast_toast-container__toast--icon-title__kezw5`,
	"toast-container__toast--close": `Toast_toast-container__toast--close__UBlT7`,
	"toast-container__toast--expand": `Toast_toast-container__toast--expand__ArSDf`,
	"toast-container__toast--rotate": `Toast_toast-container__toast--rotate__o21aN`,
	"toast-content": `Toast_toast-content__vhEya`,
	"toast-content--visible": `Toast_toast-content--visible__uf1Vj`,
	"toast-content__description": `Toast_toast-content__description__hGdgj`,
	"toast-content__buttons": `Toast_toast-content__buttons__i+Urv`,
	"toast-content__buttons--button": `Toast_toast-content__buttons--button__rz0L3`,
	"toast-content__buttons--warning": `Toast_toast-content__buttons--warning__+Q9zX`,
	"toast-content__buttons--danger": `Toast_toast-content__buttons--danger__Hiph0`,
	"toast-content__buttons--info": `Toast_toast-content__buttons--info__GGs-Z`,
	"toast-content__buttons--success": `Toast_toast-content__buttons--success__iaSi2`,
	"toast-content__buttons--link": `Toast_toast-content__buttons--link__kILC0`,
	"toastAppearanceDefault": `Toast_toastAppearanceDefault__85+wg`,
	"toastAppearanceLink": `Toast_toastAppearanceLink__k1-RF`,
	"info-icon": `Toast_info-icon__890G7`,
	"toastAppearanceSuccess": `Toast_toastAppearanceSuccess__Fx1hj`,
	"toastAppearanceWarning": `Toast_toastAppearanceWarning__Lk+3L`,
	"toastAppearanceDanger": `Toast_toastAppearanceDanger__WKZ4z`,
	"toastAppearanceInfo": `Toast_toastAppearanceInfo__HDq79`
};
export default ___CSS_LOADER_EXPORT___;
